import Repository from '@/repositories/marketing'
const resource = '/from_numbers'
export default{
    fetch(config){
		return Repository.get(`${resource}.json`, config)
    }
}